<ng-template #summaryContent>
  <div class="row g-3">

    @if (leadingTemplate) {
      <div class="col-xl col-lg-6 col-md-6">
        <ng-container *ngTemplateOutlet="leadingTemplate"></ng-container>
      </div>
    }

    <!-- Recent Activity -->
    <div class="col-lg-6 col-md-6" [ngClass]="leadingTemplate ? 'col-xl' : 'col-xl-3'">
      <div class="card card-animate h-100 mb-0 summary-card">
        <div class="card-header border-0">
          <h5 class="card-title mb-1">Recent Activity</h5>
          <p class="text-muted mb-0 small">Last 5 events</p>
        </div>
        <div class="card-body">
          <ul class="list-unstyled mb-0 summary-list">
            @for (activity of recentActivity; track $index) {
              <li class="d-flex align-items-start mb-3">
                <span class="summary-icon rounded-circle d-flex align-items-center justify-content-center me-3"
                      [ngClass]="activity.iconBg">
                  <i [ngClass]="activity.iconCls"></i>
                </span>
                <div class="flex-grow-1">
                  <p class="mb-1 small">{{activity.text}}</p>
                  <p class="text-muted small mb-0">{{activity.time}}</p>
                </div>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>

    <!-- Cost Summary -->
    <div class="col-lg-6 col-md-6" [ngClass]="leadingTemplate ? 'col-xl' : 'col-xl-3'">
      <div class="card card-animate h-100 mb-0 summary-card">
        <div class="card-header border-0">
          <h5 class="card-title mb-1">Cost Summary</h5>
          <p class="text-muted mb-0 small">Current month</p>
        </div>
        <div class="card-body">
          <ul class="list-unstyled mb-0 summary-list">
            @for (cost of costSummaryItems; track $index) {
              <li class="d-flex align-items-start mb-3">
                <span class="summary-icon rounded-circle d-flex align-items-center justify-content-center me-3"
                      [ngClass]="cost.iconBg">
                  <i [ngClass]="cost.iconCls"></i>
                </span>
                <div class="flex-grow-1">
                  <p class="mb-1 small fw-medium">{{cost.title}}</p>
                  <p class="text-muted small mb-0">{{cost.subtitle}}</p>
                </div>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>

    <!-- Licence Allocation -->
    <div class="col-lg-6 col-md-6" [ngClass]="leadingTemplate ? 'col-xl' : 'col-xl-3'">
      <div class="card card-animate h-100 mb-0 summary-card">
        <div class="card-header border-0">
          <h5 class="card-title mb-1">Licence Allocation</h5>
          <p class="text-muted mb-0 small">Company allowances</p>
        </div>
        <div class="card-body">
          <div class="mb-3">
            <div class="d-flex justify-content-between align-items-end mb-1">
              <p class="text-muted small mb-0">Overall Usage</p>
              <strong>{{licenceOverallPercent}}%</strong>
            </div>
            <div class="progress" style="height: 8px;">
              <div class="progress-bar bg-warning"
                   role="progressbar"
                   [style.width.%]="licenceOverallPercent"></div>
            </div>
            <div class="d-flex justify-content-between mt-2">
              <span class="text-muted small">Used {{licenceOverallUsed | number}}</span>
              <span class="text-muted small">Available {{licenceOverallAvailable | number}}</span>
              <span class="text-muted small">Total {{licenceOverallTotal | number}}</span>
            </div>
          </div>

          @if (licenceCompanies && licenceCompanies.length>1) {
            <ul class="list-unstyled mb-0">
              @for (company of licenceCompanies; track $index) {
                <li class="d-flex justify-content-between align-items-center py-1">
                  <span class="small">{{company.name}}</span>
                  <span class="small fw-medium">{{company.used}} / {{company.total}}</span>
                </li>
              }
            </ul>
          }
        </div>
      </div>
    </div>

    <!-- Active Alerts -->
    <div class="col-lg-6 col-md-6" [ngClass]="leadingTemplate ? 'col-xl' : 'col-xl-3'">
      <div class="card card-animate h-100 mb-0 summary-card">
        <div class="card-header border-0">
          <h5 class="card-title mb-1">Active Alerts</h5>
          <p class="text-muted mb-0 small">Requires attention</p>
        </div>
        <div class="card-body">
          <ul class="list-unstyled mb-0 summary-list">
            @for (alert of activeAlerts; track $index) {
              <li class="d-flex align-items-center mb-3"
                  [style.cursor]="canViewTriggeredAlerts ? 'pointer' : 'default'"
                  (click)="alertClick(alert)">
                <span class="summary-icon rounded-circle d-flex align-items-center justify-content-center me-3"
                      [ngClass]="alert.iconBg">
                  <i [ngClass]="alert.iconCls"></i>
                </span>
                <div class="flex-grow-1">
                  <p class="mb-1 small fw-medium">{{alert.title}}</p>
                  <p class="text-muted small mb-0">{{alert.subtitle}}</p>
                </div>
                <span class="badge bg-danger-subtle text-danger fs-6">{{alert.count}}</span>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>

  </div>
</ng-template>

@if (useContainer) {
  @if (visibleContainer) {
    <div class="row" [ngClass]="marginBottom">
      <div class="col-12">
        <div class="border border-success rounded">
          <div class="row">
            <div class="col-12">
              <div class="alert border-0 alert-primary d-flex justify-content-between align-items-center mb-0"
                   role="alert">
                <strong>{{containerTitle}}</strong>
                <div class="d-flex align-items-center" style="gap: 6px;">
                  <i class="fs-5"
                     [ngClass]="expandContainer ? 'bx bx-up-arrow' : 'bx bx-down-arrow'"
                     style="cursor: pointer; color: #198754;"
                     (click)="toggleContainerExpansion()">
                  </i>
                  <i *ngIf="allowContainerClose"
                     class="fs-3 bx bx-x"
                     style="cursor: pointer; color: #dc3545;"
                     (click)="closeContainer()">
                  </i>
                </div>
              </div>
            </div>
          </div>

          @if (expandContainer) {
            <div class="row">
              <div class="col-12">
                <div class="mb-2 w-100 px-2 pt-2">
                  <ng-container *ngTemplateOutlet="summaryContent"></ng-container>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
} @else {
  <ng-container *ngTemplateOutlet="summaryContent"></ng-container>
}
